// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Container } from "semantic-ui-react";
import "./ApplicationContent.less";
import { ApplicationError } from "../ApplicationError";
import { ApplicationModule } from "../ApplicationModule";
import { ApplicationNavigationContext } from "../ApplicationNavigation";
import { ApplicationView } from "../ApplicationView/ApplicationView";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationContent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    scope
  } = props;
  const className = [getApplicationClassName("content"), getApplicationClassName("content", scope)];
  const container = React.useRef();
  const {
    module,
    feature
  } = React.useContext(ApplicationNavigationContext);
  React.useImperativeHandle(ref, () => container.current);
  const contentView = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationView, {
    scope: scope,
    component: feature?.components?.[scope]
    // container={container}
  }, feature?.identifiant), [scope, feature]);
  const contentModule = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationModule, {
    code: module?.code,
    scope: scope,
    name: feature?.components?.[scope],
    container: container
  }, feature?.identifiant), [scope, feature, module]);
  return /*#__PURE__*/_jsx(Container, {
    className: getClassName(className),
    fluid: true,
    children: /*#__PURE__*/_jsxs(ApplicationError, {
      scope: scope,
      dependencies: [feature],
      children: [/*#__PURE__*/_jsx(Container, {
        fluid: true,
        style: {
          ...(feature?.integre && {
            display: "none"
          })
        },
        children: /*#__PURE__*/_jsx("main", {
          ref: container,
          className: module?.code
        })
      }), feature?.integre ? contentView : contentModule]
    }, scope)
  });
});